import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SearcherComponent } from 'src/app/views/content/searcher/searcher.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: true,
  imports: [SearcherComponent],
})
export class SearchComponent implements AfterViewInit, OnDestroy {
  private routeSubscription: Subscription;
  searchParams: string;

  @ViewChild(SearcherComponent) private searcher!: SearcherComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit(): void {
    this.routeSubscription = this.route.queryParams.subscribe((params) => {
      const paramsFromUrl = JSON.stringify(params);
      if (paramsFromUrl !== this.searchParams && Object.keys(params).length > 0) {
        this.searcher.searchTerm = params.textToSearch;
        this.searcher.sfSearchOptions = params.compoundOptions?.split(',');
        if (params.searchType) {
          this.searcher.searchType = params.searchType;
        }
        if (params.minScore) {
          this.searcher.minScore = params.minScore;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  updateUrl(params) {
    this.searchParams = JSON.stringify(params);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...params,
      },
      queryParamsHandling: 'merge',
    });
  }

  setQueryParams(params) {
    this.searchParams = JSON.stringify(params);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...params,
      },
      queryParamsHandling: 'merge',
    });
  }
}
